import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.troopApi + '/api/v1/'

export const getFileLists = (params) => {
  return axios.request({
    url: baseUrl + 'file_manage',
    params: params,
    method: 'get'
  })
}

export const syncS3 = (data) => {
  return axios.request({
    url: baseUrl + 's3/sync/',
    data: data,
    method: 'post'
  })
}

// 配置策略
export const getCronTransportList = (params) => {
  return axios.request({
    url: baseUrl + 'cron_transport/',
    params: params,
    method: 'get'
  })
}

export const detailCronTransport = (id) => {
  return axios.request({
    url: baseUrl + 'cron_transport/' + id + '/',
    method: 'get'
  })
}

export const editCronTransport = (data, id) => {
  let url = baseUrl + 'cron_transport/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteCronTransport = (id) => {
  return axios.request({
    url: baseUrl + 'cron_transport/' + id + '/',
    method: 'delete'
  })
}

export const cronTransportEnabledApi = (data) => {
  return axios.request({
    url: baseUrl + 'cron_transport_enabled/',
    data: data,
    method: 'post'
  })
}

export const getTransportLogList = (params) => {
  return axios.request({
    url: baseUrl + 'transport_log/',
    params: params,
    method: 'get'
  })
}

export const getAllTransportLogList = (params) => {
  return axios.request({
    url: baseUrl + 'all_transport_log/',
    params: params,
    method: 'get'
  })
}

export const getAllTransportLogSyncList = (params) => {
  return axios.request({
    url: baseUrl + 'all_transport_log_sync/',
    params: params,
    method: 'get'
  })
}

export const getRateSyncthing = (data) => {
  return axios.request({
    url: baseUrl + 'get_sync_status',
    data: data,
    method: 'post'
  })
}

export const getTransportLogResult = (id) => {
  return axios.request({
    url: baseUrl + `transport_log/${id}/result/`,
    method: 'get'
  })
}

export const syncDir = (data) => {
  return axios.request({
    url: baseUrl + 'dir/sync/',
    data: data,
    method: 'post'
  })
}
